(() => {
  'use strict';
  const menu = document.querySelector('.em-menu');
  if (menu) {
    menu.addEventListener('click', (event) => {
      if (event.target.closest('a')) menu.open = false;
    });
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && menu.open) {
        menu.open = false;
        menu.querySelector('summary').focus();
      }
    });
    document.addEventListener('click', (event) => {
      if (!menu.contains(event.target)) menu.open = false;
    });
  }
  const updateBag = () => {
    const cartPath = (window.Shopify?.routes?.root || '/') + 'cart.js';
    fetch(cartPath, {headers: {'Accept': 'application/json'}})
      .then(response => response.ok ? response.json() : null)
      .then(cart => {
        if (!cart) return;
        document.querySelectorAll('[data-em-cart-count]').forEach(element => {
          element.textContent = `(${cart.item_count})`;
          element.closest('a')?.setAttribute('aria-label', `Shopping bag, ${cart.item_count} items`);
        });
      }).catch(() => {});
  };
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, updateBag);
  }
  window.addEventListener('pageshow', updateBag);
  document.addEventListener('cart:updated', updateBag);
  document.querySelectorAll('.ep-cart-count, .bn-cart-count, .ec-cart-count').forEach(element => {
    new MutationObserver(updateBag).observe(element, {childList: true});
  });
  document.querySelectorAll('.ep-colour-swatch, .ep-thumb').forEach(element => {
    if (element.tagName === 'BUTTON') return;
    element.tabIndex = 0;
    element.setAttribute('role', 'button');
    element.setAttribute('aria-label', element.title || element.dataset.value || element.querySelector('img')?.alt || 'View product image');
    element.addEventListener('keydown', event => {
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        element.click();
      }
    });
  });
})();

(() => {
  'use strict';
  const normalize = value => String(value || '').trim().toLowerCase();
  const initGallery = gallery => {
    if (gallery.dataset.galleryReady) return;
    const main = gallery.querySelector('.ep-gallery-main');
    const thumbs = Array.from(gallery.querySelectorAll('[data-gallery-thumb]'));
    if (!main || !thumbs.length) return;
    gallery.dataset.galleryReady = 'true';
    const caption = gallery.querySelector('[data-gallery-caption]');
    const count = gallery.querySelector('[data-gallery-count]');
    const rail = gallery.querySelector('[data-gallery-thumbs]');
    const frame = gallery.querySelector('[data-gallery-frame]');
    let current = Math.max(0, thumbs.findIndex(thumb =>
      normalize(thumb.dataset.color) === normalize(gallery.dataset.initialColor) && thumb.dataset.view === 'front'
    ));
    const show = (index, reveal = false) => {
      current = (index + thumbs.length) % thumbs.length;
      const active = thumbs[current];
      main.srcset = active.dataset.gallerySrcset || '';
      main.src = active.dataset.gallerySrc;
      main.alt = active.dataset.alt;
      main.style.opacity = '1';
      thumbs.forEach(thumb => {
        const selected = thumb === active;
        thumb.classList.toggle('active', selected);
        thumb.setAttribute('aria-current', String(selected));
      });
      if (caption) caption.textContent = active.dataset.caption;
      if (count) count.textContent = `${current + 1} / ${thumbs.length}`;
      if (reveal && rail) {
        const left = active.offsetLeft - rail.offsetLeft;
        if (left < rail.scrollLeft) rail.scrollLeft = left;
        else if (left + active.offsetWidth > rail.scrollLeft + rail.clientWidth) rail.scrollLeft = left + active.offsetWidth - rail.clientWidth;
      }
    };
    thumbs.forEach((thumb, index) => thumb.addEventListener('click', () => show(index, true)));
    gallery.querySelector('[data-gallery-prev]')?.addEventListener('click', () => show(current - 1, true));
    gallery.querySelector('[data-gallery-next]')?.addEventListener('click', () => show(current + 1, true));
    gallery.addEventListener('elio:color-select', event => {
      const index = thumbs.findIndex(thumb => normalize(thumb.dataset.color) === normalize(event.detail?.color) && thumb.dataset.view === 'front');
      if (index !== -1) show(index, true);
    });
    gallery.addEventListener('keydown', event => {
      if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
      event.preventDefault();
      show(current + (event.key === 'ArrowRight' ? 1 : -1), true);
    });
    let start = null;
    let suppressZoomUntil = 0;
    frame?.addEventListener('pointerdown', event => {
      if (event.pointerType !== 'touch' || !event.isPrimary || event.target.closest('.el-gallery-arrow')) return;
      start = {x: event.clientX, y: event.clientY};
    }, {passive: true});
    frame?.addEventListener('pointercancel', () => { start = null; });
    frame?.addEventListener('pointerup', event => {
      if (!start) return;
      const dx = event.clientX - start.x;
      const dy = event.clientY - start.y;
      start = null;
      if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy) * 1.3) {
        suppressZoomUntil = Date.now() + 500;
        show(current + (dx < 0 ? 1 : -1), true);
      }
    }, {passive: true});
    frame?.addEventListener('click', event => {
      if (Date.now() < suppressZoomUntil) {
        event.preventDefault();
        event.stopImmediatePropagation();
      }
    }, true);
    show(current);
  };
  const init = root => root.querySelectorAll('[data-el-gallery]').forEach(initGallery);
  init(document);
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
